import { instance } from "./";
import notify from 'devextreme/ui/notify';

export const getResourceList = () => {
  const response = instance({
    method: "get",
    url: "/work/api/reference"
  });
  return response;
};

export const getResource = id => {
  const response = instance({
    method: "get",
    url: `/work/api/reference/${id}`
  });
  return response;
};

export const createResource = data => {
  const response = instance({
    method: "post",
    url: `/work/api/reference/`,
    data
  });
  return response;
};

export const deleteResource = id => {
  const response = instance({
    method: "delete",
    url: `/work/api/reference/${id}`
  });
  return response;
};

export const updateResource = (id, main) => {
  const data = { main: { ...main, } };

  const response = instance({
    method: "put",
    url: `/work/api/reference/${id}`,
    data
  });
  return response;
};

export const getReferenceTypes = () => {
  const response = instance({
    method: "get",
    url: "/work/api/dict/reference-type"
  });
  return response;
}

export default {
  getResourceList,
  getResource,
  createResource,
  deleteResource,
  updateResource,
  getReferenceTypes
}
